import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormModalUpdateProfilClient from "../../components/FormModalUpdateProfilClient";
import "./styles.css";

export default function ProfilClient() {
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const [showFormUpdate, setShowFormUpdate] = useState(false);

    useEffect(() => {
        if (!user || !user.profilClient) {
            navigate("/");
        }
    }, [user, navigate]);

    if (!user || !user.profilClient) {
        return null; // évite d'afficher quoi que ce soit avant la redirection
    }

    return (
        <div className="profil-container">
            <div className="profil-card">
                <h2 className="profil-title">Mon Profil Client</h2>

                <section className="profil-section">
                    <h3>Mes informations personnelles</h3>
                    <ul>

                        <li>
                            <strong>Prénom :</strong> {user.profilClient.firstNameClient}
                        </li>
                        <li>
                            <strong>Nom :</strong> {user.profilClient.lastNameClient}
                        </li>
                        <li>
                            <strong>Adresse :</strong> {user.profilClient.addressClient}
                        </li>
                        <li>
                            <strong>Code postal :</strong> {user.profilClient.postalCodeClient}
                        </li>
                        <li>
                            <strong>Ville :</strong> {user.profilClient.cityClient}
                        </li>
                    </ul>
                    {
                        user.profilClient.typeClient === 'entreprise' && (
                            <>
                                <h3>Mon entreprise</h3>
                                <ul>
                                    <li>
                                        <strong>Raison sociale :</strong> {user.profilClient.raisonSocialeClient}
                                    </li>
                                    <li>
                                        <strong>N° SIRET :</strong> {user.profilClient.numSiretClient}
                                    </li>

                                    <li>
                                        <strong>Num TVA intracommunnautaire</strong> {user.profilClient.numTvaClient}
                                    </li>
                                </ul>
                            </>

                        )
                    }

                    {
                        user.profilClient.typeClient === 'organisation' && (
                            <>
                                <h3>Mon organisation</h3>
                                <ul>
                                    <li>
                                        <strong>Nom :</strong> {user.profilClient.nameOrganisationClient}
                                    </li>
                                    <li>
                                        <strong>Type d'organisation :</strong> {user.profilClient.typeOrganisationClient}
                                    </li>
                                    <li>
                                        <strong>Numéro d'enregistrement :</strong> {user.profilClient.numEnregistrementOrganisationClient}
                                    </li>

                                </ul>
                            </>

                        )
                    }
                    {
                        user.profilClient.typeClient === 'association' && (
                            <>
                                <h3>Mon association</h3>
                                <ul>
                                    <li>
                                        <strong>Nom:</strong> {user.profilClient.nameAssociationClient}
                                    </li>
                                    <li>
                                        <strong>N° RNA :</strong> {user.profilClient.numRnaClient}
                                    </li>

                                </ul>
                            </>

                        )
                    }

                    <button className="btn-primary" onClick={() => setShowFormUpdate(true)}>METTRE A JOUR MON PROFIL</button>
                </section>
            </div>
            {
                showFormUpdate && (
                    <FormModalUpdateProfilClient onClose={() => setShowFormUpdate(false)} />
                )
            }
        </div >


    );
}
